import React from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";

const TextSections = () => {
  return (
    <div className="ml-[20px] md:ml-[100px]">
      <Section1 />
      <Section2 />
    </div>
  );
};

export default TextSections;
